export const ADMIN_DETAILS = 'ADMIN_DETAILS';
export const CUSTOMER_DETAILS = 'CUSTOMER_DETAILS'; 

export const ADD_PURCHASE_ITEM = 'ADD_PURCHASE_ITEM';
export const SAVE_PURCHASE_DETAILS = 'SAVE_PURCHASE_DETAILS';

export const EMPLOYESS_DETAILS = 'EMPLOYESS_DETAILS';